import { useState } from "react";
import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// "i" icon: hover (desktop) or tap (mobile) for a plain-English "how we got this number".
export const InfoTip = ({ title, children, tid, wide }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} data-testid={tid}
          className="inline-flex items-center text-gray-400 hover:text-indigo-600 transition-colors align-middle" aria-label={`How ${title || "this"} is calculated`}>
          <Info className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className={`${wide ? "w-[min(560px,92vw)]" : "w-80"} max-h-[70vh] overflow-auto break-words text-xs text-gray-700 normal-case tracking-normal font-normal space-y-1.5 leading-relaxed`} data-testid={tid ? `${tid}-content` : undefined}
        onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
        {title && <div className="font-bold text-gray-900 text-sm">{title}</div>}
        {children}
      </PopoverContent>
    </Popover>
  );
};

export const MathRow = ({ label, value, strong }) => (
  <div className={`flex justify-between gap-3 ${strong ? "border-t pt-1 font-bold text-gray-900" : ""}`}><span>{label}</span><span className="tabular-nums">{value}</span></div>
);
